import { render } from "./ResourcePollingButton.vue?vue&type=template&id=52a2f700"
import script from "./ResourcePollingButton.vue?vue&type=script&lang=js"
export * from "./ResourcePollingButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vacation-system/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ResourcePollingButton.vue"]])

export default __exports__